export const convertState = (state, {forward, backward}) => ({
    value: forward(state.value),
    onChange: (v) => state.onChange(backward(v)),
    ...state.change && {
        change: (reducer) => state.change((s) => backward(reducer(forward(s)))),
    },
});
